<script setup>
import common from '@/common/global';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Message } from 'view-ui-plus';

const route = useRoute();
const router = useRouter();
const linkList = ref([
  {
    name: "政府找错",
    url: "https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=bm04000008&url=http%3A%2F%2Fwww.ggzy.gov.cn%2F"
  },
  {
    name: "事业单位",
    url: "http://bszs.conac.cn/sitename?method=show&id=59FE0779EB534910E053022E1AAC7D54"
  },

])

function jump(name) {
  const item = linkList.value.find(item => item.name === name)
  if (item) {
    common.openUrl(item.url)
  }
}
const toInfo = (title) => {
  const isInfo = route.path === "/info";
  // 如果是跳转的当前页面
  if (isInfo && route.query.title === title) return;
  const url = location.href.replace(location.hash, "#/info?title=" + title);
  common.openUrl(url);
}
</script>
<template>
  <div class="bottom-footer">
    <div class="link-info">
      <div class="link-item" @click="toInfo('网站声明')">网站声明</div>
      <div class="link-item line">|</div>
      <div class="link-item" @click="toInfo('联系我们')">联系我们</div>
    </div>
    <div class="other-info">
      <div class="left">
        <!--  -->
        <img v-debounce="[jump,['政府找错']]" class="gov" src="@/assets/imgs/footer/gov.png" alt="政府" />
        <img v-debounce="[jump,['事业单位']]" class="tag" src="@/assets/imgs/footer/tag.png" alt="政府" />
      </div>
      <div class="center">
        <div>
          主办：国家信息中心&nbsp;&nbsp;&nbsp;&nbsp;指导单位：国家发展和改革委员会
        </div>
        <div>
          网站标识码：bm04000008&nbsp;&nbsp;&nbsp;&nbsp;京ICP备05052393号-9&nbsp;&nbsp;&nbsp;&nbsp;<img style="width: 16px;height: 16px; vertical-align: middle;" src="@/assets/imgs/footer/logo01.dd7ff50e.png" alt="政府" />京公网安备11010202007733号
        </div>
        <div>
          地址：北京西城区三里河路58号&nbsp;&nbsp;&nbsp;&nbsp;邮政编码：100045&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
      </div>
      <div class="qr-code">
        <img src="@/assets/imgs/footer/qr-code.png" alt="政府" />
        <div>关注“全国公共资源交易”服务号</div>
      </div>
    </div>
  </div>
</template>


<style lang="scss">
.bottom-footer {
  padding: 30px 0;
  text-align: center;
  background-color: #e4e4e4;
  color: #181818;
  font-size: 14px;

  .link-info {
    width: 162px;
    margin: 0 auto;
    font-weight: 600;
    font-size: 0;

    .link-item {
      display: inline-block;
      width: 40%;
      font-size: 14px;
      cursor: pointer;

      &.line {
        width: 20%;
        opacity: 0.3;
      }
    }
  }

  .left {
    width: 260px;
    display: inline-block;
    text-align: right;
    padding-right: 10px;

    .gov {
      width: 120px;
      margin-right: 20px;
      cursor: pointer;
    }

    .tag {
      height: 60px;
      margin-top: 15px;
      margin-bottom: -4px;
      cursor: pointer;
    }
  }

  .center {
    display: inline-block;
    font-size: 13px;
    line-height: 1.8em;
    padding: 0 20px;
  }

  .qr-code {
    width: 260px;
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
    font-size: 12px;
    margin-top: -20px;

    img {
      width: 90px;
      height: 90px;
      margin-bottom: 5px;
    }
  }
}
</style>